var OMFE = OMFE || {}; OMFE["ComponentLoader"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/omc/x/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 550);
/******/ })
/************************************************************************/
/******/ ({

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ComponentLoader = __webpack_require__(296);

Object.defineProperty(exports, 'load', {
  enumerable: true,
  get: function get() {
    return _ComponentLoader.load;
  }
});
Object.defineProperty(exports, 'unload', {
  enumerable: true,
  get: function get() {
    return _ComponentLoader.unload;
  }
});

/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.load = load;
exports.loadPending = loadPending;
exports.unload = unload;
/* eslint no-throw-literal:0 */
/* global React:true,ReactDOM:true,OMFE:true,buildVersion:true */

/**
 * handleOutdatedBrowser - adds an 'outdated' message to the container
 *
 * @param  {type} appendTarget DOM Node
 * @return {type}              none
 */
function handleOutdatedBrowser(appendTarget) {
    var outdatedColor = '#f2b635';

    var target = appendTarget;
    target.innerHTML = '\n        <div style="position: relative; height: 100%; width:100%; background-color: ' + outdatedColor + ';">\n            <table style="height: 100%; width: 100%;"><tr><td style="vertical-align:middle; text-align:center; color: #fff;">\n                <h3 style="text-transform: uppercase;">Your Browser Is Out-of-Date!</h3>\n                <p>Update your browser to view this website correctly. </p>\n                <a href="http://outdatedbrowser.com/"\n                    target="_blank"\n                    style="display: block; border:1px solid #fff; width: 70%; margin: 0 auto; line-height: 30px; text-decoration: none; ' + ('color: #fff; text-transform: uppercase; font-size: 13px"\n                    onMouseOver="javascript:this.style.backgroundColor=\'#fff\';this.style.color=\'' + outdatedColor + '\';"\n                    onMouseOut="javascript:this.style.backgroundColor=\'\';this.style.color=\'#fff\';"\n                >\n                    Update my browser now\n                </a>\n            </td></tr></table>\n        </div>\n    ');
}

/**
 * load - Loads a specific ReactJS OMFEProduct
 *
 * @param  {string} OMFEComponent           name of component to load
 * @param  {DOMNode} container              container in which to load the component via ReactDOM.render
 * @param  {object} props = {}              default props to pass to OMFEComponent
 * @param  {array}  children                children to pass to OMFEComponent
 * @return {mixed}                          irrelevant return value
 */
var isBusy = false;
var pendingLoad = [];
function load() {
    var OMFEComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
    var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var children = arguments[3];

    // Busy State
    if (isBusy) {
        pendingLoad.push({ OMFEComponent: OMFEComponent, container: container, props: props, children: children });
        return false;
    }
    isBusy = true;

    // OMFE Components Configuration
    window.OMFECONFIG = window.OMFECONFIG || {};
    window.OMFECONFIG.distUrl = window.OMFECONFIG.distUrl || 'https://static.glastcoper.com/omc/p';
    var distUrl = window.OMFECONFIG.distUrl;

    // Validate Component and appendTarget

    var Component = /^OMFE[A-Za-z0-9]+$/.test(OMFEComponent) && OMFEComponent || function () {
        throw 'Invalid OMFEComponent supplied';
    }() && false;
    var appendTarget = container || function () {
        throw 'Invalid container supplied';
    }() && false;

    // Unsupported browser - < IE8, feature-detect getElementsByClassName
    if (document.getElementsByClassName === undefined) {
        handleOutdatedBrowser(appendTarget);
        return false;
    }

    // React, ReactDOM, OMFECore and requested OMFEComponent
    var dependencies = [{ src: !document.getElementById(Component + 'Style') && distUrl + '/' + Component + '.css?v=' + "1.0.5414" || 0, type: 'css', id: Component + 'Style' }, { src: !window.React && distUrl + '/React.js?v=' + "1.0.5414" || 0, type: 'js' }, { src: !window.ReactDOM && distUrl + '/ReactDOM.js?v=' + "1.0.5414" || 0, type: 'js' }, { src: (!window.OMFE || !window.OMFE.OMFECore) && distUrl + '/OMFECore.js?v=' + "1.0.5414" || 0, type: 'js' }, { src: (!window.OMFE || !window.OMFE[Component]) && distUrl + '/' + Component + '.js?v=' + "1.0.5414" || 0, type: 'js' }];

    // Loads other components once rendered
    var loadOtherComponents = function loadOtherComponents() {
        if (!pendingLoad || !pendingLoad.length) {
            return false; // we're done
        }
        /* eslint no-shadow: 0 */
        var _pendingLoad$ = pendingLoad[0],
            OMFEComponent = _pendingLoad$.OMFEComponent,
            container = _pendingLoad$.container,
            props = _pendingLoad$.props,
            children = _pendingLoad$.children;

        pendingLoad = pendingLoad.slice(1);
        return load(OMFEComponent, container, props, children);
    };

    // Renders once done
    var loadComponent = function loadComponent() {
        ReactDOM.unmountComponentAtNode(appendTarget);
        appendTarget.innerHTML = '';
        var newProps = props;
        newProps.store = newProps.store !== undefined && newProps.store || OMFE.OMFECore.store;
        ReactDOM.unmountComponentAtNode(appendTarget);
        ReactDOM.render(React.createElement(OMFE[Component].default, newProps, children), appendTarget);
        if (window && window.MutationObserver) {
            var observer = new MutationObserver(function () {
                if (appendTarget.parentNode === null) {
                    observer.disconnect();
                    ReactDOM.unmountComponentAtNode(appendTarget);
                }
            });
            observer.observe(appendTarget.parentNode, { childList: true });
            // state of the art polyfill
        } else {
            var interval = setInterval(function () {
                if (appendTarget.parentNode === null) {
                    clearInterval(interval);
                    ReactDOM.unmountComponentAtNode(appendTarget);
                }
            }, 1000);
        }
        isBusy = false;
        return loadOtherComponents();
    };

    // Recurses until all dependencies are loaded
    var d = document;
    var currentDependency = -1;
    var loadNextDependency = function loadNextDependency() {
        currentDependency++;
        if (currentDependency >= dependencies.length) {
            loadComponent();
            return false;
        }
        var _dependencies$current = dependencies[currentDependency],
            src = _dependencies$current.src,
            type = _dependencies$current.type,
            id = _dependencies$current.id;

        if (!src || !src.length) {
            loadNextDependency();
            return false;
        }

        switch (type) {
            case 'js':
                {
                    var scriptLoaded = false;
                    var script = d.createElement('script');
                    script.type = 'text/javascript';
                    script.src = src;
                    script.id = id || 'l' + Math.round(new Date().getTime() + Math.random() * 1000001);
                    script.onload = function () {
                        if (!scriptLoaded) {
                            scriptLoaded = true;
                            loadNextDependency();
                        }
                        if (script.parentNode) {
                            script.parentNode.removeChild(script);
                        }
                    };
                    if (script.readyState !== undefined) {
                        script.onreadystatechange = function () {
                            if (!scriptLoaded && (!script.readyState || script.readyState === 'loaded' || script.readyState === 'complete')) {
                                scriptLoaded = true;
                                loadNextDependency();
                            }
                            if (script.parentNode) {
                                script.parentNode.removeChild(script);
                            }
                        };
                    }
                    appendTarget.appendChild(script);
                    break;
                }
            case 'css':
                {
                    var head = d.getElementsByTagName('head');
                    head = head.length && head[0] || d.getElementsByTagName('body');
                    head = head.parentNode && head || head.length && head[0] || appendTarget;

                    var link = d.createElement('link');
                    link.rel = 'stylesheet';
                    link.media = 'all';
                    link.type = 'text/css';
                    link.href = src;
                    link.id = id || 'l' + Math.round(Date.now() + Math.random() * 1000001);
                    var existingStyles = d.getElementsByTagName('link');
                    if (existingStyles.length > 0) {
                        head.insertBefore(link, existingStyles[0]);
                    } else {
                        head.appendChild(link);
                    }
                    loadNextDependency();
                    break;
                }
            // ignores other extensions
            default:
                {
                    loadNextDependency();
                    break;
                }
        }
        return false;
    };

    // Start loading
    return loadNextDependency();
}

/**
 * loadPending - executes all functions under OMFE.ComponentLoaderReady
 */
function loadPending() {
    if (!window || !window.OMFE || !window.OMFE.ComponentLoaderReady || !window.OMFE.ComponentLoaderReady.length) {
        return;
    }

    var pendingLoad = window.OMFE.ComponentLoaderReady;

    var _loop = function _loop(i) {
        if (pendingLoad[i]) {
            setTimeout(function () {
                return pendingLoad[i](window.OMFE);
            });
        }
    };

    for (var i = 0; i < pendingLoad.length; i++) {
        _loop(i);
    }
    window.OMFE.ComponentLoaderReady = [];
}

/**
 * unload - unloads a loaded component, regardless of whether that component has finished loading or not
 *
 * @param  {DOMNode} container              container in which to load the component via ReactDOM.render
 * @return {boolean}                        returns true or false
 */
function unload() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

    var appendTarget = container;

    if (!appendTarget) {
        console.error('Invalid container supplied in unload');
        return false;
    }

    if (typeof ReactDOM !== 'undefined') {
        return ReactDOM.unmountComponentAtNode(appendTarget);
    }

    return false;
}

/**
 * Execute loadPending() once this module is defined
 */
setTimeout(function () {
    return loadPending();
});

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(293);


/***/ })

/******/ });


// WEBPACK FOOTER //
// ComponentLoader.js